import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';
import IToken from 'interfaces/IToken';

export async function callApi(refreshToken: IToken): Promise<Optional<void>> {
	const url: string = `${SERVICEBASEURL.USER}/User/Logout`;
	return axios.post(url, { refreshToken: refreshToken.token });
}
